import OrgClassicBook from './src/main.js'

const components = []
const install = function (Vue, opts = {}) {
  if (install.installed) return
  components.forEach(component => {
    Vue.component(component.name, component)
  })
  Vue.prototype.$OrgClassicBook = OrgClassicBook
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default { install }
